import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../../api/apiService";
import { toast } from "react-toastify";

const ActivateUser = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [activationMessage, setActivationMessage] = useState("");
  const [activationError, setActivationError] = useState("");

  useEffect(() => {
    if (token) {
      activateUser(token);
    } else {
      setIsLoading(false);
      setActivationError("No activation token provided.");
    }
  }, [token]);

  const activateUser = async (activationToken) => {
    try {
      const response = await api.get(`activate/${activationToken}`);
      setIsLoading(false);

      if (response.data.status) {
        setActivationMessage(response.data.message);
        toast.success("Account activated successfully");

        // Redirect to login page after a delay
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setActivationError(response.data.message);
      }
    } catch (error) {
      setIsLoading(false);

      // Handle different types of errors
      if (error.response && error.response.data && error.response.data.message) {
        setActivationError(error.response.data.message);
      } else {
        setActivationError("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title text-center">Account Activation</h5>

              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              {!isLoading && activationMessage && (
                <div className="alert alert-success text-center">
                  {activationMessage}
                </div>
              )}

              {!isLoading && activationError && (
                <div className="alert alert-danger text-center">
                  {activationError}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivateUser;
